import axios from 'axios';
import { API_BASE_URL } from '../environment';
import { getToken, logout } from '../helpers/storage';

import endpoints from './endpoints';

const defaultParams = {
  apikey: '',
};

const defaultConfig = {
  headers: { 'Content-Type': 'application/json' },
  baseURL: API_BASE_URL,
};

axios.interceptors.request.use((config) => {
  const newConfig = {
    ...config,
  };
  const token = getToken();
  if (token) {
    newConfig.headers.common.Authorization = `JWT ${getToken()}`;
  }
  return newConfig;
});

function ApiClient(headerName = 'Bearer', addToken = true) {
  this.instance = axios.create(defaultConfig);

  if (addToken) {
    this.instance.interceptors.request.use((config) => {
      const newConfig = {
        ...config,
      };
      const token = getToken();
      if (token) {
        newConfig.headers.common.Authorization = `${headerName} ${getToken()}`;
      }
      return newConfig;
    });
  }
  this.instance.interceptors.response.use((response) => response,
    (error) => {
      if (error
        && error.response
        && error.response.status
        && error.response.status === 401
      ) {
        logout();
        if (window.location.pathname !== '/login') {
          window.location = '/login';
          return null;
        }
      }
      return Promise.reject(error);
    });

  /* this.instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        console.log("Error! ", error.response);
        return Promise.reject(error);
      },
  ); */

  Object.keys(endpoints).forEach((endpoint) => {
    this[endpoint] = endpoints[endpoint](this.instance, defaultParams);
  });
}

const apiClient = new ApiClient();
const apiClientJwt = new ApiClient('JWT');
const apiClientNoToken = new ApiClient('', false);

export { apiClient as default, apiClientJwt, apiClientNoToken };
